module.exports = __webpack_public_path__ + "img/language.6dbf2535.png";